import { render, staticRenderFns } from "./dealings.vue?vue&type=template&id=0aef19f8&"
import script from "./dealings.vue?vue&type=script&lang=js&"
export * from "./dealings.vue?vue&type=script&lang=js&"
import style0 from "./dealings.vue?vue&type=style&index=0&id=0aef19f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports